import JSONAPISerializer from '@ember-data/serializer/json-api';
import { camelize } from '@ember/string';

export default class EmployeeVisitMetricsSerializer extends JSONAPISerializer {
  modelNameFromPayloadKey() {
    return 'employee-visit-metrics';
  }

  keyForAttribute(key) {
    return key;
  }

  normalize(model, hash) {
    if (hash.attributes) {
      const transformedAttrs = {};
      Object.keys(hash.attributes).forEach((key) => {
        transformedAttrs[camelize(key)] = hash.attributes[key];
      });

      hash.attributes = transformedAttrs;
    }

    return super.normalize(model, hash);
  }
}
